import { TextField } from "@mui/material";
import { CustomComponentProps } from "utils/types/general.types";
import Dropdown from "../core/Dropdown";
import { useState } from "react";

export type CardFilterProps = CustomComponentProps & {
    dropDownItems?: string[];
    showFullTitle?: boolean;
};

const CardFilter = ({
    dropDownItems = [],
    showFullTitle = false,
    className,
    style
}: CardFilterProps) => {
    const [selected, setSelected] = useState(
        dropDownItems.length ? dropDownItems[0] : ""
    );

    return (
        <div
            className={`w-full flex justify-between items-center gap-3 ${className}`}
            style={style}
        >
            <TextField
                id="search-country-wise-download"
                name="search-country-wise-download"
                label={`Search${showFullTitle ? ` ${selected}` : ""}`}
                variant="outlined"
                size="small"
                sx={{ width: "100%" }}
                // value={filter}
                // onChange={(e) => setFilter(e.target.value)}
            />
            {dropDownItems.length && (
                <Dropdown
                    selected={selected}
                    handleSelect={setSelected}
                    title="Search by:"
                    items={dropDownItems}
                />
            )}
        </div>
    );
};

export default CardFilter;
